export const UPLOADABLE_MIME_TYPES = [
  'image/gif',
  'image/png',
  'image/jpeg',
  'text/plain',
  'text/csv',
  'text/rtf',
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/x-iwork-keynote-sffkey',
  'application/x-iwork-pages-sffpages',
  'application/x-iwork-numbers-sffnumbers',
];

export type StringMap = Record<string, string>;
export const BUSINESS_PARTNER_DISPLAY_TYPES: StringMap = {
  both: 'プロジェクト（売上・費用）の両方に表示',
  sales: 'プロジェクト（売上）にのみ表示',
  purchase: 'プロジェクト（費用）にのみ表示',
};
